function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function FieldTextArea(_param) {
    var { id = "input", value = "", rows = 3, style = {}, fontSize, maxChar = 500, disabled = false, showCount = false, onBlur, onChange } = _param, rest = _object_without_properties(_param, [
        "id",
        "value",
        "rows",
        "style",
        "fontSize",
        "maxChar",
        "disabled",
        "showCount",
        "onBlur",
        "onChange"
    ]);
    const handleChange = (event)=>{
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
    };
    const handleBlur = (event)=>{
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
    };
    const styles = {
        column: {
            display: "flex",
            flexDirection: "column"
        },
        textarea: _object_spread(_object_spread_props(_object_spread({}, fontSize && {
            fontSize
        }), {
            padding: "8px",
            resize: "none",
            cursor: "text",
            fontFamily: "inherit",
            textAlign: "justify",
            border: "1px solid #9a9a9b",
            borderRadius: "4px",
            backgroundColor: "#e1f5fe"
        }), style)
    };
    return /*#__PURE__*/ _jsxs("div", {
        style: styles.column,
        children: [
            /*#__PURE__*/ _jsx("textarea", _object_spread({
                id: id,
                value: value,
                rows: rows,
                disabled: disabled,
                onChange: handleChange,
                onBlur: handleBlur,
                style: styles.textarea
            }, rest)),
            showCount && /*#__PURE__*/ _jsx("div", {
                className: "noprint",
                style: {
                    textAlign: "right",
                    marginTop: "4px"
                },
                children: `${value.length}/${maxChar}`
            })
        ]
    });
}
